// extracted by mini-css-extract-plugin
export var orderSummary = "_sx-0";
export var showMoreLessButton = "_sx-1";